import { COUNTRIES_TOP, COUNTRIES_ALL_ALPHABETIC } from "@/lib/countries";

/**
 * Länder-Dropdown mit priorisiertem Top-Block (DE, AT, CH, NL, IT) und alphabetischer Restliste.
 * Nutzt natives <select> für maximale Mobil-Kompatibilität.
 */
export default function CountrySelect({ value, onChange, required, testid, placeholder = "Bitte wählen …" }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      data-testid={testid}
      className="h-11 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-800 focus:border-indigo-400 focus:ring-1 focus:ring-indigo-200 focus:outline-none"
    >
      <option value="" disabled>{placeholder}</option>
      <optgroup label="Häufig">
        {COUNTRIES_TOP.map((c) => <option key={c} value={c}>{c}</option>)}
      </optgroup>
      <optgroup label="Alle Länder">
        {COUNTRIES_ALL_ALPHABETIC.map((c) => <option key={c} value={c}>{c}</option>)}
      </optgroup>
    </select>
  );
}
